export class DetailsOfCreditor {
  claimantType: number;
  firstName: string;
  lastName: string;
  creditorName:string;
  postalAddressLine1: string;
  postalAddressLine2: string;
  postalAddressLine3: string;
  postalCountry: string;
  postalCode: number;
  iscorrespondenceSameAsPostal: boolean;
  correspondenceMailingAddressLine1: string;
  correspondenceMailingAddressLine2: string;
  correspondenceMailingAddressLine3: string;
  correspondenceMailingCountry: string;
  correspondenceMailingPostalCode: number;
  emailAddress: string;
  creditorReferenceNumber: number;
  deliveryMode: string;
  creditorUEN: string;
  nricfinPassportNo: string;
  companyName: string;
  engagementId: string;
  countryCode: number;
  contactNumber: number;
  creditorContact: CreditorContact[] = [];
}
export class CreditorContact {
  countryCode: number;
  contactNumber: number;
}
export class UserAccountDetails {
  userId: string;
  firstName: string;
  lastName: string;
  emailAddress: string;
    roleName: any;
  
}
export class EngagementDetails {
  engagementId: string;
  engagementName: string;
}
export class CreditorDetailsList {
  creditorId: string;
  creditorName: string;
}
export class UserContact {
  countryCode: number;
  contactNumber: number;
}
export class UserRole {
  roleName:string
}

export enum ClaimantTypeEnum{
  IndividualEmployee=1,
  IndividualNonEmployee=7,
  CorporateFinancialInstitution=2,
  CorporateGovernmentBody=3,
  CorporateInterCompany=4,
  CorporateThirdParty=5,
  CorporateOthers=6
}